export default __webpack_public_path__ + "static/media/menu_plus.854c5a1a.svg";